<mat-checkbox [formControl]="dynamicFormField.formControl"
              *ngIf="viewMode === 'form'">
  {{ dynamicFormField.label }}
</mat-checkbox>
<ellipse-dynamic-summary-field *ngIf="viewMode === 'summary'"
                               [label]="dynamicFormField.label"
                               [value]="dynamicFormField.formControl.value"/>
